<template>
  <div class="bg-natural-soft-white p-4 rounded-md text-center w-full">
      <TsImage class=" inline " :src="props.image" alt="deal" width="64" height="64" loading="lazy"/>
      <TsTypography as="p" align="center" append-class="text-primary  mb-0">{{ props.title }}</TsTypography>
  </div>
</template>

<script setup lang="ts"> 
type Props = {
    image: string,
    title: string,
}

const props = withDefaults(defineProps<Props>(), {
  image: '/images/clarity_user-line.svg',
  title: 'My Account'
})
</script>